import { useApiTradeV1TradeCompaniesRetrieve } from 'api';
import { useTranslation } from 'i18n';
import { Link, useParams } from 'react-router-dom';
import { Button, Page, Section } from 'ui';

import { BuyerMaterialSpecificationList } from '../../components/BuyerMaterialSpecificationList/BuyerMaterialSpecificationList';

export const BuyerMaterialSpecificationsListPage = () => {
  const { t } = useTranslation('orders');
  const { companyId } = useParams();
  const { data: tradeCompany } = useApiTradeV1TradeCompaniesRetrieve(Number(companyId));

  return (
    <Page>
      <Page.BackButton
        component="a"
        href={`/ground-control/manage_company/${tradeCompany?.company_id}/`}
        disabled={!tradeCompany}
      >
        {t('buyerMaterialSpecifications.listPage.actions.manageCompany', {
          values: { companyName: tradeCompany?.name },
        })}
      </Page.BackButton>

      <Page.Title title={t('buyerMaterialSpecifications.listPage.title')} />
      <Page.Divider />
      <Section
        title={t('buyerMaterialSpecifications.listPage.sectionTitle')}
        action={
          tradeCompany ? (
            <Button component={Link} to="new">
              {t('buyerMaterialSpecifications.listPage.actions.addMaterialSpecification')}
            </Button>
          ) : null
        }
      >
        {tradeCompany ? <BuyerMaterialSpecificationList tradeCompanyId={tradeCompany.id} /> : null}
      </Section>
    </Page>
  );
};
